/* eslint-disable react/prop-types */
import styles from './styles.module.css'
// import { CircleX, Cross, Interrogation } from '../../../../assets/svgs/icons'

import { useTranslation } from 'react-i18next'
const ModalAwaitAiGenerate = ({ isOpen }) => {
  if (!isOpen) return null

  const { t } = useTranslation()

  return (
    <div className={styles.modal_overlay}>
      <div className={styles.modal}>
        {/* <div className={styles.header_close}>
          <div className={styles.close_modal} onClick={onClose}>
            <Cross width={'20px'} height={'20px'} />
          </div>
        </div> */}

        <div className={styles.modal_title}>
          <h2>Aguarde!</h2>
        </div>

        <div className={styles.modal_sub_title}>
          <p className={styles.modal_sub_title_text}>
            {t('Estamos preparando tudo para iniciar a geração das imagens!')}
          </p>
        </div>
      </div>
    </div>
  )
}

export default ModalAwaitAiGenerate
